/**
 * Color design token reference: https://slate.faire.team/tokens/colors (version = Slate 1)
 */
export enum ColorTokenKey {
  COLOR_TOKEN_KEY_UNKNOWN = 'COLOR_TOKEN_KEY_UNKNOWN',
  /**
   * Equivalent in new foundations: Color.ACTION_BORDER_DEFAULT
   * @deprecated
   */
  ACTION_BORDER_DEFAULT = 'ACTION_BORDER_DEFAULT',
  /**
   * Equivalent in new foundations: Color.ACTION_BORDER_DISABLED
   * @deprecated
   */
  ACTION_BORDER_DISABLED = 'ACTION_BORDER_DISABLED',
  /**
   * Equivalent in new foundations: Color.ACTION_BORDER_DEFAULT
   * @deprecated
   */
  ACTION_BORDER_ENABLED = 'ACTION_BORDER_ENABLED',
  /**
   * Equivalent in new foundations: Color.ACTION_BORDER_HOVER
   * @deprecated
   */
  ACTION_BORDER_HOVER = 'ACTION_BORDER_HOVER',
  /**
   * Equivalent in new foundations: Color.ACTION_BORDER_SUBDUED
   * @deprecated
   */
  ACTION_BORDER_MUTED = 'ACTION_BORDER_MUTED',
  /**
   * Equivalent in new foundations: Color.ACTION_BORDER_SUBDUED
   * @deprecated
   */
  ACTION_BORDER_SUBDUED = 'ACTION_BORDER_SUBDUED',
  /**
   * Equivalent in new foundations: Color.ACTION_ICON_DEFAULT
   * @deprecated
   */
  ACTION_ICON_DEFAULT = 'ACTION_ICON_DEFAULT',
  /**
   * Equivalent in new foundations: Color.ACTION_ICON_DISABLED
   * @deprecated
   */
  ACTION_ICON_DISABLED = 'ACTION_ICON_DISABLED',
  /**
   * Equivalent in new foundations: Color.ACTION_ICON_ACTIVE
   * @deprecated
   */
  ACTION_ICON_ENABLED = 'ACTION_ICON_ENABLED',
  /**
   * Equivalent in new foundations: Color.ACTION_ICON_HOVER
   * @deprecated
   */
  ACTION_ICON_HOVER = 'ACTION_ICON_HOVER',
  /**
   * Equivalent in new foundations: Color.ACTION_ICON_INVERSE
   * @deprecated
   */
  ACTION_ICON_MUTED = 'ACTION_ICON_MUTED',
  /**
   * Equivalent in new foundations: Color.ACTION_ICON_SUBDUED
   * @deprecated
   */
  ACTION_ICON_SUBDUED = 'ACTION_ICON_SUBDUED',
  /**
   * Equivalent in new foundations: Color.ACTION_SURFACE_DEFAULT
   * @deprecated
   */
  ACTION_SURFACE_DEFAULT = 'ACTION_SURFACE_DEFAULT',
  /**
   * Equivalent in new foundations: N/A - raw value is #757575
   * @deprecated
   */
  ACTION_SURFACE_DISABLED = 'ACTION_SURFACE_DISABLED',
  /**
   * Equivalent in new foundations: Color.ACTION_SURFACE_ACTIVE
   * @deprecated
   */
  ACTION_SURFACE_ENABLED = 'ACTION_SURFACE_ENABLED',
  /**
   * Equivalent in new foundations: Color.ACTION_SURFACE_HOVER
   * @deprecated
   */
  ACTION_SURFACE_HOVER = 'ACTION_SURFACE_HOVER',
  /**
   * Equivalent in new foundations: Color.ACTION_SURFACE_INVERSE
   * @deprecated
   */
  ACTION_SURFACE_MUTED = 'ACTION_SURFACE_MUTED',
  /**
   * Equivalent in new foundations: Color.SURFACE_TERTIARY
   * @deprecated
   */
  ACTION_SURFACE_SUBDUED = 'ACTION_SURFACE_SUBDUED',
  /**
   * Equivalent in new foundations: Color.ACTION_TEXT_DEFAULT
   * @deprecated
   */
  ACTION_TEXT_DEFAULT = 'ACTION_TEXT_DEFAULT',
  /**
   * Equivalent in new foundations: Color.ACTION_TEXT_DISABLED
   * @deprecated
   */
  ACTION_TEXT_DISABLED = 'ACTION_TEXT_DISABLED',
  /**
   * Equivalent in new foundations: Color.ACTION_TEXT_ACTIVE
   * @deprecated
   */
  ACTION_TEXT_ENABLED = 'ACTION_TEXT_ENABLED',
  /**
   * Equivalent in new foundations: Color.ACTION_TEXT_HOVER
   * @deprecated
   */
  ACTION_TEXT_HOVER = 'ACTION_TEXT_HOVER',
  /**
   * Equivalent in new foundations: Color.ACTION_TEXT_INVERSE
   * @deprecated
   */
  ACTION_TEXT_MUTED = 'ACTION_TEXT_MUTED',
  /**
   * Equivalent in new foundations: Color.ACTION_TEXT_PLACEHOLDER
   * @deprecated
   */
  ACTION_TEXT_SUBDUED = 'ACTION_TEXT_SUBDUED',
  /**
   * Equivalent in new foundations: Color.SURFACE_PRIMARY
   * @deprecated
   */
  CORE_BACKGROUND_PRIMARY = 'CORE_BACKGROUND_PRIMARY',
  /**
   * Equivalent in new foundations: Color.SURFACE_SECONDARY
   * @deprecated
   */
  CORE_BACKGROUND_SECONDARY = 'CORE_BACKGROUND_SECONDARY',
  /**
   * Equivalent in new foundations: Color.SURFACE_TERTIARY
   * @deprecated
   */
  CORE_BACKGROUND_TERTIARY = 'CORE_BACKGROUND_TERTIARY',
  /**
   * Equivalent in new foundations: Color.MESSAGE_BORDER_CRITICAL
   */
  CORE_BORDER_CRITICAL = 'CORE_BORDER_CRITICAL',
  /**
   * Equivalent in new foundations: Color.BORDER_MUTED
   */
  CORE_BORDER_PRIMARY = 'CORE_BORDER_PRIMARY',
  /**
   * Equivalent in new foundations: Color.MESSAGE_BORDER_SUCCESS
   */
  CORE_BORDER_SUCCESS = 'CORE_BORDER_SUCCESS',
  /**
   * Equivalent in new foundations: Color.MESSAGE_BORDER_WARNING
   */
  CORE_BORDER_WARNING = 'CORE_BORDER_WARNING',
  /**
   * Equivalent in new foundations: Color.MESSAGE_ICON_CRITICAL
   */
  CORE_ICON_CRITICAL = 'CORE_ICON_CRITICAL',
  /**
   * Equivalent in new foundations: Color.ICON_PRIMARY
   */
  CORE_ICON_PRIMARY = 'CORE_ICON_PRIMARY',
  /**
   * Equivalent in new foundations: Color.ICON_SUBDUED
   */
  CORE_ICON_SECONDARY = 'CORE_ICON_SECONDARY',
  /**
   * Equivalent in new foundations: Color.MESSAGE_ICON_SUCCESS
   */
  CORE_ICON_SUCCESS = 'CORE_ICON_SUCCESS',
  /**
   * Equivalent in new foundations: Color.MESSAGE_ICON_WARNING
   */
  CORE_ICON_WARNING = 'CORE_ICON_WARNING',
  /**
   * Equivalent in new foundations: Color.MESSAGE_SURFACE_CRITICAL
   */
  CORE_SURFACE_CRITICAL = 'CORE_SURFACE_CRITICAL',
  /**
   * Equivalent in new foundations: Color.MESSAGE_SURFACE_SUCCESS
   */
  CORE_SURFACE_SUCCESS = 'CORE_SURFACE_SUCCESS',
  /**
   * Equivalent in new foundations: Color.MESSAGE_SURFACE_WARNING
   */
  CORE_SURFACE_WARNING = 'CORE_SURFACE_WARNING',
  /**
   * Equivalent in new foundations: Color.MESSAGE_TEXT_CRITICAL
   */
  CORE_TEXT_CRITICAL = 'CORE_TEXT_CRITICAL',
  /**
   * Equivalent in new foundations: Color.TEXT_PRIMARY
   */
  CORE_TEXT_PRIMARY = 'CORE_TEXT_PRIMARY',
  /**
   * Equivalent in new foundations: Color.TEXT_PRIMARY_INVERSE
   */
  CORE_TEXT_PRIMARY_INVERSE = 'CORE_TEXT_PRIMARY_INVERSE',
  /**
   * Equivalent in new foundations: Color.TEXT_SUBDUED
   */
  CORE_TEXT_SECONDARY = 'CORE_TEXT_SECONDARY',
  /**
   * Equivalent in new foundations: N/A - raw value is #B5A998
   */
  DECORATIVE_ICON_10 = 'DECORATIVE_ICON_10',
  /**
   * Equivalent in new foundations: N/A - raw value is #BA9B88
   */
  DECORATIVE_ICON_20 = 'DECORATIVE_ICON_20',
  /**
   * Equivalent in new foundations: Color.EXPRESSIVE_TEXT_ORANGE
   */
  DECORATIVE_ICON_30 = 'DECORATIVE_ICON_30',
  /**
   * Equivalent in new foundations: N/A - raw value is #A79764
   */
  DECORATIVE_ICON_40 = 'DECORATIVE_ICON_40',
  /**
   * Equivalent in new foundations: Color.PROGRAM_ICON_TOP_SHOP
   */
  DECORATIVE_ICON_50 = 'DECORATIVE_ICON_50',
  /**
   * Equivalent in new foundations: Color.PROGRAM_ICON_INSIDER
   */
  DECORATIVE_ICON_60 = 'DECORATIVE_ICON_60',
  /**
   * Equivalent in new foundations: Color.MESSAGE_BORDER_INFO
   */
  DECORATIVE_ICON_70 = 'DECORATIVE_ICON_70',
  /**
   * Equivalent in new foundations: Color.EXPRESSIVE_TEXT_BLUE
   */
  DECORATIVE_SHADE_10 = 'DECORATIVE_SHADE_10',
  /**
   * Equivalent in new foundations: Color.EXPRESSIVE_TEXT_RED
   */
  DECORATIVE_SHADE_20 = 'DECORATIVE_SHADE_20',
  /**
   * Equivalent in new foundations: Color.MESSAGE_TEXT_SALE
   */
  DECORATIVE_SHADE_30 = 'DECORATIVE_SHADE_30',
  /**
   * Equivalent in new foundations: Color.EXPRESSIVE_TEXT_YELLOW
   */
  DECORATIVE_SHADE_40 = 'DECORATIVE_SHADE_40',
  /**
   * Equivalent in new foundations: Color.PROGRAM_TEXT_TOP_SHOP
   */
  DECORATIVE_SHADE_50 = 'DECORATIVE_SHADE_50',
  /**
   * Equivalent in new foundations: Color.PROGRAM_TEXT_INSIDER
   */
  DECORATIVE_SHADE_60 = 'DECORATIVE_SHADE_60',
  /**
   * Equivalent in new foundations: Color.EXPRESSIVE_TEXT_BLUE
   */
  DECORATIVE_SHADE_70 = 'DECORATIVE_SHADE_70',
  /**
   * Equivalent in new foundations: Color.EXPRESSIVE_SURFACE_NEUTRAL
   */
  DECORATIVE_TINT_10 = 'DECORATIVE_TINT_10',
  /**
   * Equivalent in new foundations: Color.EXPRESSIVE_SURFACE_RED
   */
  DECORATIVE_TINT_20 = 'DECORATIVE_TINT_20',
  /**
   * Equivalent in new foundations: Color.EXPRESSIVE_SURFACE_ORANGE
   */
  DECORATIVE_TINT_30 = 'DECORATIVE_TINT_30',
  /**
   * Equivalent in new foundations: Color.EXPRESSIVE_SURFACE_YELLOW
   */
  DECORATIVE_TINT_40 = 'DECORATIVE_TINT_40',
  /**
   * Equivalent in new foundations: Color.EXPRESSIVE_SURFACE_GREEN
   */
  DECORATIVE_TINT_50 = 'DECORATIVE_TINT_50',
  /**
   * Equivalent in new foundations: Color.PROGRAM_SURFACE_INSIDER_PRIMARY
   */
  DECORATIVE_TINT_60 = 'DECORATIVE_TINT_60',
  /**
   * Equivalent in new foundations: Color.EXPRESSIVE_TEXT_BLUE
   */
  DECORATIVE_TINT_70 = 'DECORATIVE_TINT_70',
  /**
   * Equivalent in new foundations: N/A - closest is Color.PROGRAM_ICON_TOP_SHOP
   */
  TOP_SHOP_ICON_GREEN = 'TOP_SHOP_ICON_GREEN',
  /**
   * Equivalent in new foundations: N/A - closest is Color.PROGRAM_SURFACE_TOP_SHOP_PRIMARY_INVERSE
   */
  TOP_SHOP_SHADE_GREEN = 'TOP_SHOP_SHADE_GREEN',
  /**
   * Equivalent in new foundations: N/A - closest is Color.PROGRAM_SURFACE_TOP_SHOP_PRIMARY
   */
  TOP_SHOP_TINT_GREEN = 'TOP_SHOP_TINT_GREEN',
  /**
   * Equivalent in new foundations: Color.ACTION_SURFACE_DISABLED
   */
  CORE_SURFACE_DISABLED = 'CORE_SURFACE_DISABLED',
  /**
   * https://www.figma.com/design/mDFMOehyo1z5YWGDxh2lXV/%F0%9F%8C%9E-Faire-Summer-Market-2024
   * Equivalent in new foundations: N/A
   */
  CORE_SURFACE_PRIMARY_MARKET = 'CORE_SURFACE_PRIMARY_MARKET',
  /**
   * Equivalent in new foundations: N/A
   */
  CORE_BADGE_ICON_MARKET = 'CORE_BADGE_ICON_MARKET',
  /**
   * Equivalent in new foundations: Color.ACTION_SURFACE_ACTIVE
   */
  CORE_SURFACE_ENABLED = 'CORE_SURFACE_ENABLED',
  /**
   * Equivalent in new foundations: N/A
   */
  CORE_BACKGROUND_PRIMARY_MARKET = 'CORE_BACKGROUND_PRIMARY_MARKET',
}
